<template>
  <div id="add">
    <Loading v-if="loading"></Loading>
    <van-form class="content">
      <van-cell-group inset>
        <!-- <van-cell @click="showToast"> -->
        <van-cell>
          <van-field
            autocomplete="off"
            v-model="form.scName"
            name="scName"
            label="仓库"
            inputmode="none"
            disabled
        /></van-cell>
        <van-cell>
          <!-- <van-cell @click="showToast"> -->
          <van-field
            autocomplete="off"
            v-model="form.supplierName"
            name="supplierName"
            inputmode="none"
            label="供应商"
            disabled
        /></van-cell>
        <!-- <van-cell>
          <van-field
            autocomplete="off"
            v-model="form.purchaserName"
            name="purchaserName"
            label="采购员"
        /></van-cell> -->
        <van-cell @click="openDateTimePicker('form', 'paymentDate')">
          <van-field
            autocomplete="off"
            v-model="form.paymentDate"
            name="paymentDate"
            inputmode="none"
            :required="!form.allowModifyPaymentDate"
            label="付款日期"
        /></van-cell>
        <van-cell @click="showPurchaseOrderSelect">
          <!-- <van-cell> -->
          <van-field
            autocomplete="off"
            v-model="form.receiveSheetId"
            name="receiveSheetId"
            inputmode="none"
            readonly
            required
            label="采购收货单"
        /></van-cell>
        <van-cell>
          <van-field
            autocomplete="off"
            v-model="form.description"
            rows="1"
            autosize
            label="备注"
            type="textarea"
          />
        </van-cell>
      </van-cell-group>
      <!-- <van-form style="margin: 16px 0">
        <div class="action">
          <Van-icon
            name="add-o"
            type="primary"
            @click="toShowProductSelect"
          ></Van-icon>
        </div>
        <CustomTable
          :scrollWidth="600"
          :showPagination="false"
          :columns="columns"
          :tableData="tableData"
        ></CustomTable>
      </van-form> -->
      <van-form style="margin-top: 5px" class="product-list">
        <div class="flex-between top">
          <div>商品列表</div>
          <!-- 退货单不允许新增商品 -->
          <!-- <div class="action">
            <Van-icon
              name="add-o"
              type="primary"
              @click="toCategory"
            ></Van-icon>
          </div> -->
        </div>
        <van-cell v-for="(item, i) in form.tableData">
          <div class="product" @click="toDetail(item)">
            <div class="flex flex-start">
              <div class="tit">{{ item.productName }}</div>
              <div class="price">
                <span>￥{{ item.purchasePrice }}</span
                >/{{ item.unit }}
              </div>
              <div class="desc">库存数量:{{ item.stockNum || "-" }}</div>
              <div class="desc">剩余可退货数量:{{ item.remainNum || "-" }}</div>
            </div>
            <div class="flex flex-end">
              <div class="total">
                ￥{{ $utils.mul(item.purchasePrice, item.returnNum) }}
              </div>
              <div>
                <div class="numChangeBox" @click.stop="">
                  <van-icon
                    class="circleIcon"
                    name="minus"
                    @click="minus($event, i, 'returnNum')"
                  />
                  <van-field
                    class="numInput"
                    type="number"
                    v-model="item.returnNum"
                  >
                  </van-field>
                  <van-icon
                    class="circleIcon"
                    name="plus"
                    @click="plus($event, i, 'returnNum')"
                  />
                </div>
              </div>
            </div>
            <van-icon name="arrow" />
          </div>
        </van-cell>
      </van-form>

      <div style="margin: 16px 0">
        <van-form>
          <van-cell>合计</van-cell>
          <van-cell-group>
            <van-cell
              ><van-field
                autocomplete="off"
                label="退货数量"
                readonly
                v-model="form.totalNum"
                type="number"
            /></van-cell>
            <van-cell
              ><van-field
                autocomplete="off"
                label="赠品数量"
                readonly
                type="number"
                v-model="form.giftNum"
            /></van-cell>
            <van-cell
              ><van-field
                autocomplete="off"
                label="含税总金额"
                readonly
                type="number"
                v-model="form.totalAmount"
            /></van-cell>
          </van-cell-group>
        </van-form>
        <van-cell class="actions-btn">
          <van-button
            type="primary"
            @click="onAddConfirm"
            round
            block
            :loading="loading"
            >保存</van-button
          >
          <van-button
            type="info"
            @click="toDirectApprovePass"
            round
            block
            :loading="loading"
            v-permission="'purchase:return:approve'"
            >直接审批通过</van-button
          >
          <van-button
            @click="close"
            type="default"
            round
            block
            :loading="loading"
            >关闭</van-button
          >
        </van-cell>
      </div>
    </van-form>
    <ProductSelect
      v-if="showProductSelect"
      type="order"
      columnsType="checkbox"
      :scId="this.form.scId"
      :visible="showProductSelect"
      @confirm="onSelectProductConfirm"
    ></ProductSelect>
    <DateTimePicker
      value-format="yyyy-MM-dd"
      :showPicker="showDatePicker"
      @confirm="onDatePickerConfirm"
      @cancel="showDatePicker = false"
    ></DateTimePicker>
    <ReceiveSheetSelect
      v-show="receiveSheetSelectVisible"
      :visible="receiveSheetSelectVisible"
      @confirm="receiveSheetSelectConfirm"
    ></ReceiveSheetSelect>
  </div>
</template>

<script>
import {
  create,
  directApprovePass,
} from "../../../service/api/purchase/return";
import SupplierSelect from "../../../components/supplierSelect.vue";
import ProductSelect from "../../../components/productSelect.vue";
import StockSelect from "../../../components/stockSelect.vue";
import CustomTable from "../../../components/customTable.vue";
import DateTimePicker from "../../../components/dateTimePicker.vue";
import { Notify, Toast, Dialog } from "vant";
import moment, { RFC_2822 } from "moment";
import ReceiveSheetSelect from "../../../components/receiveSheetSelect.vue";
import {
  getWithReturn,
  getPaymentDate,
} from "../../../service/api/purchase/receive";
import Loading from "../../../components/loading.vue";

export default {
  name: "index",
  components: {
    CustomTable,
    ProductSelect,
    StockSelect,
    SupplierSelect,
    DateTimePicker,
    ReceiveSheetSelect,
    Loading,
  },
  data() {
    return {
      loading: false,
      receiveSheetSelectVisible: false,
      showDatePicker: false,
      showDatePicker: false,
      stockSelectVisible: false,
      supplierSelectVisible: false,
      showProductSelect: false,
      datePickType: "product",
      form: {
        tableData: [],
        allowModifyPaymentDate: false,
      },
      tableData2: [],
      columns: [
        {
          field: "productName",
          key: "productName",
          title: "商品名称",
          width: 100,
          fixed: "left",
        },
        {
          field: "productCode",
          key: "productCode",
          title: "商品编号",
          width: 80,
        },
        { field: "unit", key: "unit", title: "单位", width: 80 },
        { field: "spec", key: "spec", title: "规格", width: 80 },
        {
          field: "categoryName",
          key: "categoryName",
          title: "商品类目",
          width: 80,
        },
        {
          field: "isGift",
          key: "isGift",
          title: "是否赠品",
          width: 50,
          formatter: ({ cellValue }) => {
            return cellValue ? "是" : "否";
          },
        },
        { field: "brandName", key: "brandName", title: "商品品牌", width: 80 },
        {
          field: "purchasePrice",
          key: "purchasePrice",
          title: "采购价（元）",
          align: "right",
          width: 100,
        },
        {
          field: "taxCostPrice",
          key: "taxCostPrice",
          title: "含税成本价（元）",
          width: 100,
        },
        { field: "stockNum", key: "stockNum", title: "库存数量", width: 100 },
        {
          field: "receiveNum",
          key: "receiveNum",
          title: "收货数量",
          width: 100,
        },
        {
          field: "remainNum",
          key: "remainNum",
          title: "剩余退货数量",
          width: 100,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const value = this.$utils.sub(row.remainNum, row.returnNum);
            return <span>{value}</span>;
          },
        },
        {
          field: "returnNum",
          key: "returnNum",
          title: "退货数量",
          width: 100,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const text = row[column.field];
            return (
              <van-field
                autocomplete="off"
                name="returnNum"
                value={text}
                type="number"
                on-input={(val) =>
                  this.inputChange(rowIndex, column.field, val)
                }
              ></van-field>
            );
          },
        },
        {
          field: "taxAmount",
          key: "taxAmount",
          title: "含税金额",
          align: "right",
          width: 80,
        },
        {
          field: "description",
          key: "description",
          title: "备注",
          width: 80,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const text = row[column.field];
            return (
              <van-field
                autocomplete="off"
                name="description"
                value={text}
                type="number"
                on-input={(val) =>
                  this.inputChange(rowIndex, column.field, val)
                }
              ></van-field>
            );
          },
        },
        {
          field: "",
          key: "e",
          title: "操作",
          width: "",
          center: "left",
          fixed: "right",
          width: 50,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span class="action">
                <van-icon
                  name="delete-o"
                  on-click={() => this.deleteRow(rowIndex)}
                ></van-icon>
              </span>
            );
          },
        },
      ],
      orderingKey: "",
      queryType: "",
    };
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        localStorage.setItem(this.orderingKey, JSON.stringify(newVal));
        if (newVal.tableData && newVal.tableData.length > 0) this.calcSum();
        else {
          this.form.totalNum = 0;
          this.form.giftNum = 0;
          this.form.totalAmount = 0;
        }
        if (
          newVal.receiveSheetId &&
          (!newVal.tableData || newVal.tableData.length === 0)
        ) {
          this.get(newVal.receiveSheetId);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {},
  mounted() {
    if (this.$route.query.type && this.$route.query.type.includes("purchase")) {
      this.queryType = this.$route.query.type;
      this.orderingKey = this.$route.query.type + "ing";
      const orderFrom = JSON.parse(
        localStorage.getItem(this.orderingKey) || "{}"
      );
      const form = Object.assign({}, this.form, orderFrom);
      this.form = { ...form };
    }
  },
  methods: {
    get(id) {
      this.loading = true;
      getWithReturn(id)
        .then((res) => {
          const data = res.data;
          const tableData =
            (this.form.tableData &&
              this.form.tableData.filter((item) => !item.isFixed)) ||
            [];
          let receiveSheetDetails = data.details || [];
          receiveSheetDetails = receiveSheetDetails.map((item) => {
            item.isFixed = true;
            return Object.assign(this.emptyProduct(), item);
          });
          this.form.tableData = [...receiveSheetDetails, ...tableData].map(
            (item) => {
              return Object.assign(this.emptyProduct(), item);
            }
          );

          this.form.scId = data.scId;

          this.form.supplierId = data.supplierId;

          if (!this.$utils.isEmpty(data.purchaserId)) {
            this.form.purchaserId = data.purchaserId;
          }
          this.form = { ...this.form };

          this.supplierChange(this.form.supplierId);
        })

        .finally(() => {
          this.loading = false;
        });
    },
    toCategory() {
      this.$router.push({
        path: "/product/category",
        query: { type: this.queryType },
      });
    },
    toDetail(item) {
      this.$router.push({
        path: "/purchase/returnProductModify/" + item.productId,
        query: { type: "edit" },
      });
    },
    minus(event, i, key) {
      event.stopPropagation();
      if (this.form.tableData[i][key] <= 1 && this.form.tableData[i].isFixed) {
        Toast("采购收货单中的商品不允许删除");
        return;
      } else if (
        this.form.tableData[i][key] <= 0 &&
        !this.form.tableData[i].isFixed
      ) {
        this.form.tableData.splice(i, 1);
        return;
      }
      let num = this.$utils.preciseSubtraction(
        Number(this.form.tableData[i][key]),
        1
      );
      this.$set(this.form.tableData[i], key, num);
    },
    plus(event, i, key) {
      event.stopPropagation();

      let num = Number(this.form.tableData[i][key]) + 1;
      this.$set(this.form.tableData[i], key, num);
    },
    close() {
      Dialog.confirm({
        title: "警告",
        message: "关闭页面将会丢失数据，确认关闭？",
      })
        .then(() => {
          this.$router.push({ path: "/dashboard/home" });
        })
        .catch(() => {});
    },
    showToast() {
      Toast.fail("请先选择采购收货单");
    },
    toShowProductSelect() {
      if (!this.form.scId) {
        Toast.fail("请先选择仓库");
        return;
      }
      this.showProductSelect = true;
    },
    genParams() {
      const params = {
        scId: this.form.scId,
        supplierId: this.form.supplierId,
        purchaserId: this.form.purchaserId || "",
        paymentDate: this.form.paymentDate || "",
        receiveSheetId: this.form.receiveSheetId,
        description: this.form.description,
        required: true,
        products: this.form.tableData
          .filter((t) => this.$utils.isFloatGtZero(t.returnNum))
          .map((t) => {
            const product = {
              productId: t.productId,
              returnNum: t.returnNum,
              description: t.description,
            };

            if (t.isFixed) {
              product.receiveSheetDetailId = t.id;
            }

            return product;
          }),
      };
      return params;
    },
    addDays(date, days) {
      if (!date || !days) {
        return "";
      }
      const result = new Date(date);
      result.setDate(result.getDate() + Number(days));
      return moment(result).format("YYYY-MM-DD");
    },
    // 校验数据
    validData() {
      if (this.$utils.isEmpty(this.form.scId)) {
        this.$utils.createError("仓库不允许为空！");
        return false;
      }

      if (this.$utils.isEmpty(this.form.supplierId)) {
        this.$utils.createError("供应商不允许为空！");
        return false;
      }

      if (this.form.allowModifyPaymentDate) {
        if (this.$utils.isEmpty(this.form.paymentDate)) {
          this.$utils.createError("付款日期不允许为空！");
          return false;
        }
      }

      if (this.$utils.isEmpty(this.form.receiveSheetId)) {
        this.$utils.createError("采购收货单不允许为空！");
        return false;
      }

      if (this.$utils.isEmpty(this.form.tableData)) {
        this.$utils.createError("请录入商品！");
        return false;
      }

      for (let i = 0; i < this.form.tableData.length; i++) {
        const product = this.form.tableData[i];

        if (this.$utils.isEmpty(product.productId)) {
          this.$utils.createError("第" + (i + 1) + "行商品不允许为空！");
          return false;
        }

        if (this.$utils.isEmpty(product.purchasePrice)) {
          this.$utils.createError("第" + (i + 1) + "行商品采购价不允许为空！");
          return false;
        }

        if (!this.$utils.isFloat(product.purchasePrice)) {
          this.$utils.createError("第" + (i + 1) + "行商品采购价必须为数字！");
          return false;
        }

        if (product.isGift) {
          if (parseFloat(product.purchasePrice) !== 0) {
            this.$utils.createError("第" + (i + 1) + "行商品采购价必须等于0！");
            return false;
          }
        } else {
          if (!this.$utils.isFloatGtZero(product.purchasePrice)) {
            this.$utils.createError("第" + (i + 1) + "行商品采购价必须大于0！");
            return false;
          }
        }

        if (!this.$utils.isNumberPrecision(product.purchasePrice, 2)) {
          this.$utils.createError(
            "第" + (i + 1) + "行商品采购价最多允许2位小数！"
          );
          return false;
        }

        if (!this.$utils.isEmpty(product.returnNum)) {
          if (product.isFixed) {
            if (!this.$utils.isFloatGeZero(product.returnNum)) {
              this.$utils.createError(
                "第" + (i + 1) + "行商品退货数量不允许小于0！"
              );
              return false;
            }
          } else {
            if (!this.$utils.isTotalNumGtZero(product.returnNum)) {
              this.$utils.createError(
                "第" + (i + 1) + "行商品退货数量必须大于0并且最多三位小数！"
              );
              return false;
            }
          }

          if (product.isFixed) {
            console.log(
              Number(product.returnNum),
              product.remainNum,
              Number(product.returnNum) > product.remainNum
            );
            if (Number(product.returnNum) > product.remainNum) {
              this.$utils.createError(
                "第" +
                  (i + 1) +
                  "行商品累计退货数量为" +
                  (product.receiveNum - product.remainNum) +
                  "，剩余退货数量为" +
                  product.remainNum +
                  "，本次退货数量不允许大于" +
                  product.remainNum +
                  "！"
              );
              return false;
            }
          }
        } else {
          if (!product.isFixed) {
            this.$utils.createError(
              "第" + (i + 1) + "行商品退货数量不允许为空！"
            );
            return false;
          }
        }
      }

      if (
        this.form.tableData.filter((item) =>
          this.$utils.isFloatGtZero(item.returnNum)
        ).length === 0
      ) {
        this.$utils.createError("采购收货单中的商品必须全部或部分退货！");
        return false;
      }

      return true;
    },
    toDirectApprovePass() {
      if (!this.validData()) {
        this.loading = false;
        return;
      }
      try {
        const checkStockNumArr = [];
        this.form.tableData
          .filter((item) => this.$utils.isFloatGtZero(item.returnNum))
          .forEach((item) => {
            if (
              checkStockNumArr
                .map((v) => item.productId)
                .includes(item.productId)
            ) {
              checkStockNumArr
                .filter((v) => v.productId === item.productId)
                .forEach((v) => {
                  v.returnNum = this.$utils.add(v.returnNum, item.returnNum);
                });
            } else {
              checkStockNumArr.push({
                productId: item.productId,
                productCode: item.productCode,
                productName: item.productName,
                stockNum: item.stockNum,
                returnNum: item.returnNum,
              });
            }
          });

        const unValidStockNumArr = checkStockNumArr.filter(
          (item) => item.stockNum < item.returnNum
        );
        if (!this.$utils.isEmpty(unValidStockNumArr)) {
          this.$utils.createError(
            "商品（" +
              unValidStockNumArr[0].productCode +
              "）" +
              unValidStockNumArr[0].productName +
              "当前库存为" +
              unValidStockNumArr[0].stockNum +
              "，总退货数量为" +
              unValidStockNumArr[0].returnNum +
              "，无法完成采购退货！"
          );
          return false;
        }
        const params = this.genParams();
        this.loading = true;
        directApprovePass(params)
          .then((res) => {
            Toast.success(res.msg);
            this.$router.push({ path: "/purchase/return" });
          })
          .finally(() => {
            this.loading = false;
          });
      } catch (error) {
        if (error.isCanceled) return;
        this.loading = false;
      }
    },
    onAddConfirm() {
      if (!this.validData()) {
        this.loading = false;
        return;
      }
      try {
        this.loading = true;
        const params = this.genParams();

        create(params)
          .then((res) => {
            Toast.success(res.msg);
            this.$router.push({ path: "/purchase/return" });
          })
          .finally(() => {
            this.loading = false;
          });
      } catch (error) {
        if (error.isCanceled) return;
        this.loading = false;
      }
    },

    // 计算汇总数据
    calcSum() {
      let totalNum = 0;
      let giftNum = 0;
      let totalAmount = 0;

      this.form.tableData
        .filter((t) => {
          return (
            this.$utils.isFloatGeZero(t.purchasePrice) &&
            this.$utils.isFloatGtZero(t.returnNum)
          );
        })
        .forEach((t) => {
          const num = parseFloat(t.returnNum);
          if (t.isGift) {
            giftNum = this.$utils.add(giftNum, num);
          } else {
            totalNum = this.$utils.add(totalNum, num);
          }

          totalAmount = this.$utils.add(
            totalAmount,
            this.$utils.mul(num, t.purchasePrice)
          );
        });

      this.form.totalNum = totalNum;
      this.form.giftNum = giftNum;
      this.form.totalAmount = totalAmount;
    },
    showPurchaseOrderSelect() {
      this.receiveSheetSelectVisible = true;
    },
    emptyProduct() {
      return {
        id: this.$utils.uuid(),
        productId: "",
        productCode: "",
        productName: "",
        skuCode: "",
        externalCode: "",
        unit: "",
        spec: "",
        categoryName: "",
        brandName: "",
        purchasePrice: 0,
        taxCostPrice: "",
        stockNum: "",
        receiveNum: "",
        remainNum: "",
        returnNum: 0,
        taxRate: "",
        isGift: true,
        taxAmount: "",
        description: "",
        isFixed: false,
        products: [],
      };
    },
    receiveSheetSelectConfirm(row) {
      if (Object.keys(row).length === 0) {
        this.receiveSheetSelectVisible = false;
        return;
      }
      this.form = {};
      getWithReturn(row.id)
        .then((res) => {
          const data = res.data;
          const tableData = this.form.tableData.filter((item) => !item.isFixed);
          let receiveSheetDetails = data.details || [];
          receiveSheetDetails = receiveSheetDetails.map((item) => {
            item.isFixed = true;

            return Object.assign(this.emptyProduct(), item);
          });
          this.form.tableData = [...receiveSheetDetails, ...tableData];

          this.form.scId = data.scId;

          this.form.supplierId = data.supplierId;

          if (!this.$utils.isEmpty(data.purchaserId)) {
            this.form.purchaserId = data.purchaserId;
          }

          this.supplierChange(this.form.supplierId);
        })

        .finally(() => {
          this.loading = false;
        });
      this.receiveSheetSelectVisible = false;
      this.form.receiveSheetId = row.id;
      this.form.scName = row.scName;
      this.form.scId = row.scCode;
      this.form.supplierName = row.supplierName;
      this.form.supplierId = row.supplierCode;
    },
    supplierChange(supplierId) {
      getPaymentDate(supplierId).then((res) => {
        this.form.paymentDate = res.data.paymentDate || "";
        this.form.allowModifyPaymentDate = res.data.allowModify;
        this.$forceUpdate();
      });
    },
    inputChange(rowIndex, field, val) {
      this.$set(this.form.tableData, rowIndex, {
        ...this.form.tableData[rowIndex],
        [field]: val,
      });
    },
    openDateTimePicker(type = "product", index) {
      this.datePickType = type;
      this.index = index;
      this.showDatePicker = true;
    },
    deleteRow(index) {
      this.form.tableData.splice(index, 1);
    },
    onSelectProductConfirm(row) {
      if (this.showProductSelect) {
        this.showProductSelect = false;
      }
      if (row.length) {
        row.forEach((el) => {
          this.form.tableData.push({
            ...el,
          });
        });
      }
    },
    onDatePickerConfirm(val) {
      if (!val) return;
      if (this.datePickType == "product") {
        this.$set(this.form.tableData, this.index, {
          ...this.form.tableData[this.index],
          productionDate: val,
        });
      } else {
        this.form[this.index] = val;
      }
      this.showDatePicker = false;
      this.index = 0;
    },
  },
};
</script>
<style scoped lang="less">
.van-cell {
  padding: 5px 0px 5px 15px;
}

#add {
  position: relative;
  /* height: 100vh;
  overflow: auto; */
}

::v-deep .van-field__body {
  height: 100%;
}

.actions-btn {
  .van-button {
    margin: 5px 5px 0 0;
  }
}

.action {
  background-color: #fff;
  padding-left: 20px;
  display: flex;
  align-items: center;
  font-size: 26px;
  height: 36px;
}

.content {
  .product-list {
    background-color: #fff;
    max-height: 60vh;
    overflow: auto;

    .top {
      background-color: #fff;
      padding: 10px;
      font-size: 16px;
    }

    .action {
      background-color: #fff;
      padding-left: 20px;
      display: flex;
      align-items: center;
      font-size: 26px;
      height: 36px;
    }
  }

  .product {
    padding-right: 8px;
    font-size: 14px;
    color: #999;
    display: flex;
    width: 100%;
    justify-content: space-between;

    .van-icon-arrow {
      width: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .flex {
      display: flex;
      justify-items: center;
      flex-direction: column;
      align-content: flex-start;
      justify-content: center;
      align-items: flex-start;
      flex: 1;
    }

    .flex-end {
      align-items: flex-end;
    }

    .tit {
      max-width: 230px;
      font-size: 16px;
      font-weight: 600;
      color: #000;
    }

    .price span {
      font-weight: 500;
      color: #347f5e;
    }

    .total {
      font-weight: 600;
      color: red;
    }
  }
}

.van-cell-group--inset {
  margin: 0px;
  border-radius: 0px;
}
</style>
